import { Component, EventEmitter, Output, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'tk-vehicle-list-full-tacho-header',
    templateUrl: './vehicle-list-full-tacho-header.component.html',
    styleUrls: ['./vehicle-list-full-tacho-header.component.less']
})
export class VehicleListFullTachoHeaderComponent {
    @Output()
    public onValueChanged: EventEmitter<any> = new EventEmitter();

    @ViewChild('select__toggle', { read: ElementRef }) selectButton: any;

    public showList = false;

    public currentValues: string[] = [];

    public items: string[] = [];

    public toggleShowList() {
        this.showList = !this.showList;
        if (this.showList === true) {
            this.selectButton.nativeElement.focus();
        }
    }

    public closeShowList() {
        setTimeout(() => {
            this.showList = false;
        }, 300);
    }

    resetValue() {
        this.currentValues = [];
        this.onValueChanged.emit(this.currentValues);
        this.toggleShowList();
    }

    selectAll() {
        this.currentValues = ['driving', 'resting', 'free', 'working'];
        this.onValueChanged.emit(this.currentValues);
        this.toggleShowList();

    }

    onSelect(val: string) {
        const idx = this.currentValues.indexOf(val);
        if (idx === -1) {
            this.currentValues.push(val);
        } else {
            this.currentValues.splice(idx, 1);
        }
        this.onValueChanged.emit(this.currentValues);
        this.toggleShowList();
    }

    constructor(
        private $el: ElementRef) { }
}



